module.exports = __webpack_public_path__ + "static/media/centrosdeaprenizaje.6a13af8c.svg";